import React from "react";
import { Grid } from "@material-ui/core";

import { EXECUTION_BRIEF_HOOK } from "../../../pages/execution-brief/types/execution-brief-template.interface";
import { TemplateName } from "../../../types/templates/template-name";
import { UserGroup } from "../../../constants/types";
import { useExecutionBriefTemplateOptions } from "../../../pages/execution-brief/types/execution-brief-template.hooks";

import { BorderedBlock } from "../../common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../forms/fields/checkbox-field/checkbox-field.component";
import { RichTextField } from "../../forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { SelectField } from "../../forms/fields/select-field/select-field.component";
import { StatusSection } from "../../common-attributes/components/status-section/status-section.component";
import { UserSearchField } from "../../forms/fields/user-search-field/user-search-field.component";

import {
  IS_REGIONAL,
  LANGUAGES,
  MERCH_OWNERS,
  PROGRAM_OBJECTIVES,
  REQUEST_DETAILS,
} from "../constants";

import { IExecutionBriefTemplate, pageType } from ".";
import { HiddenHeading } from "../../../pages/pages.styles";

export const ExecutionBriefInStoreDigitalTemplate = (props: IExecutionBriefTemplate) => {
  const { languagesOptions, regionsOptions } = useExecutionBriefTemplateOptions([
    EXECUTION_BRIEF_HOOK.LANGUAGES,
    EXECUTION_BRIEF_HOOK.REGIONS,
  ]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={REQUEST_DETAILS.TITLE}
            name={REQUEST_DETAILS.ID}
            required
            subTitle={TemplateName.ExecutionBrief.InStoreDigital}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={PROGRAM_OBJECTIVES.TITLE}
            name={PROGRAM_OBJECTIVES.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
      </Grid>
      <Grid item xs={12} md={4}>
        <StatusSection
          form={props.form}
          label="Status"
          name="status"
          pageType={pageType}
          userPermissions={props.userPermissions}
        />
        <BorderedBlock>
          <SelectField
            form={props.form}
            label={LANGUAGES.TITLE}
            multiple
            name={LANGUAGES.ID}
            options={languagesOptions}
            placeholder="Select Language"
            required
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <UserSearchField
            form={props.form}
            groupFilter={UserGroup.MERCH_OWNERS}
            label={MERCH_OWNERS.TITLE}
            name={MERCH_OWNERS.ID}
            resourceId={props.resourceId}
            resourceType={props.resourceType}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={IS_REGIONAL.TITLE}
            name={IS_REGIONAL.ID}
            userPermissions={props.userPermissions}
          >
            <SelectField
              form={props.form}
              label="Regions"
              multiple
              name="regions"
              options={regionsOptions}
              placeholder="Select Region"
              userPermissions={props.userPermissions}
            />
          </CheckboxField>
        </BorderedBlock>
      </Grid>
    </Grid>
  );
};
